module.exports = __webpack_public_path__ + "static/media/vector_background.a0d7520f.svg";